import { useEffect, useState } from "react";
import "./App.css";

import { getDescryptedText } from "./util/app";
import { firestore } from "./firebase";
import MainScreen from "./screen/MainScreen";
import ErrorScreen from "./screen/ErrorScreen";
import TeamInviteScreen from "./screen/TeamInviteScreen";
import PrivacyPolicyScreen from "./screen/PrivacyPolicyScreen";
// 앱의 기본 uri scheme (기기 내에서의 이동 경로)
export const defaultScheme = "momocalendar://";

function App() {
  // 링크에 전달된 파라미터 값
  const inviteCode = window.location.pathname.slice(1);

  // 앱이 생성한 링크의 팀 코드 (팀 id로 디코딩할 수 있는 key값)
  const teamId = getDescryptedText(inviteCode);

  const [teamData, setTeamData] = useState(null);
  const [stateCode, setStateCode] = useState({});
  const [availableLinks, setAvailableLinks] = useState([]);

  useEffect(() => {
    if (teamId !== "") {
      firestore
        .collection("teamData")
        .doc(teamId)
        .get()
        .then((data) => {
          if (data !== undefined) {
            const newTeamData = data.data();
            setTeamData(newTeamData);
          }
        });
    } else if (inviteCode && teamId === "") {
      setTeamData(undefined);
    }
  }, [inviteCode, teamId]);

  // 있으면, 3일 간의 도큐먼트를 돌면서 존재하는지 확인
  useEffect(() => {
    if (teamId !== "") {
      // 3일이 지난 도큐먼트는 삭제하므로 전체 도큐먼트를 확인하면 됨
      firestore
        .collection("inviteLink")
        .get()
        .then((date) =>
          date.forEach((doc) => {
            const inviteLink = doc.data();
            if (Object.keys(inviteLink).includes(teamId)) {
              setAvailableLinks((prev) => [...prev, ...inviteLink[teamId]]);
            }
          })
        );
    }
  }, [teamId]);

  // 상태에 맞는 코드로 화면 띄우기
  useEffect(() => {
    if (availableLinks.includes(inviteCode)) {
      setStateCode({ code: 201, msg: "Created" });
    } else if (inviteCode === "privacypolicy") {
      setStateCode({ code: 999, msg: "Privacy Policy" });
    } else if (teamData === undefined) {
      setStateCode({ code: 404, msg: "Not Found" });
    } else {
      setStateCode({ code: 200, msg: "OK" });
    }
  }, [availableLinks, inviteCode, teamId, teamData]);

  return (
    <div className="App">
      <MainScreen stateCode={stateCode} />
      <ErrorScreen stateCode={stateCode} />
      <TeamInviteScreen
        stateCode={stateCode}
        inviteCode={inviteCode}
        teamData={teamData}
      />
      <PrivacyPolicyScreen stateCode={stateCode} />
    </div>
  );
}

// const styles = {};

export default App;
